import React, { useEffect, useState } from 'react';
import DataTable, { SortOrder } from 'react-data-table-component';
import { http } from '../helper';
import { BaseUrl } from '../common/config';
import DatePicker from "react-datepicker";
import { format } from 'date-fns';
import moment from "moment";
import * as XLSX from "sheetjs-style";
import { saveAs } from "file-saver";
import { canAction } from '../common/permissionhelper';
export const Loggedinnotordered = ({ }) => {

    const priceFormat = (price) => {
        return price.toLocaleString("en-US", {
            style: "currency",
            currency: "GBP",
            minimumFractionDigits: 2,
        });
    };

    const columns = [
        {
            name: "Account Code",
            selector: row => row.accountCode,
            sortable: false,
        },
        {
            name: "Account Name",
            selector: row => row.accountName,
            sortable: false,
        },
        {
            name: "Email Address",
            selector: row => row.accountEmail,
            sortable: false,
        },
        {
            name: "Last Logged In",
            selector: row => moment(row.lastLogin).format("DD/MM/YYYY HH:mm:ss"),
            sortable: false,
        }

    ];

    const customStyles = {
        rows: {
            style: {
                minHeight: '25px',
            },
        },
        headCells: {
            style: {
                padding: '8px', // override the cell padding for head cells

            },
        },
        cells: {
            style: {
                padding: '8px', // override the cell padding for data cells

            },
        },
    };

    const paginationComponentOptions = {
        rowsPerPageText: "",
        rangeSeparatorText: "",
        selectAllRowsItem: true,
        selectAllRowsItemText: "",
        noRowsPerPage: "",
    };
    var currentTime = new Date();
    var currentyear = currentTime.getFullYear();
    var currentMonth = currentTime.getUTCMonth() + 1;
    const [filter, setFilter] = useState(0);
    const [filtertext, setFilterText] = useState('');
    const [topOrderedCustomers, setTopOrderedCustomers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const getCurrentFiscalYear = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth() + 1;
        // Fiscal year starts in September
        const startYear = month >= 9 ? year : year - 1;
        const endYear = startYear + 1;
        return `${startYear}-${endYear}`;
    };
    const [period, setPeriod] = useState(getCurrentFiscalYear());
    const [months, setMonths]=useState('9');
    const [quarter,setQuarter]=useState('');
    const [restrictedAccounts, setRestrictedAccounts] = useState([]); // store restricted accounts
    const [restrictedLoaded, setRestrictedLoaded] = useState(false);
    const [showExportAlert, setShowExportAlert] = useState(false);
    const [showNoDataAlert, setShowNoDataAlert] = useState(false);
    //const excludeTestids = ['K2BTE003','K2BTE005','K2BTE001','K2BTE002','TESTA004','TESTA005','TESTA007','IEPIZ001','TESTA099'];
    const MonthNames = ["Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"];
    const currentFiscalMonth = new Date().getMonth(); // 0-indexed: Jan = 0, Apr = 3, Sep = 8
    
    useEffect(() => {
    http.get(BaseUrl + 'admin/accountcodelist') // get restricted accounts
        .then((res) => {
            const ids = res.data?.data?.map(acc => acc.accountCode);
            setRestrictedAccounts(ids || []);
        })
        .catch((err) => {
            console.error("Failed to fetch restricted accounts", err);
            setRestrictedAccounts([]);
        })
        .finally(() => {
            setRestrictedLoaded(true);
        });
    }, []);

    const quarterNames = {
    1: "Sep - Nov",
    2: "Dec - Feb",
    3: "Mar - May",
    4: "Jun - Aug"
    };

    const getCurrentFiscalQuarter = () => {
    const month = new Date().getMonth() + 1; // 1–12
    if (month >= 9 && month <= 11) return 1;   // Sep–Nov
    if (month === 12 || month <= 2) return 2;  // Dec–Feb
    if (month >= 3 && month <= 5) return 3;    // Mar–May
    return 4;                                  // Jun–Aug
    };

        const getAvailableQuarters = (selectedFiscalYear) => {
        const currentFiscalYear = getCurrentFiscalYear();
        const currentQuarter = getCurrentFiscalQuarter();

        return Object.entries(quarterNames)
            .filter(([quarterNumber]) => {
            if (selectedFiscalYear === currentFiscalYear) {
                return Number(quarterNumber) <= currentQuarter;
            }
            return true; // show all for past years
            })
            .map(([quarterNumber, label]) => (
            <option key={quarterNumber} value={quarterNumber}>
                {label}
            </option>
            ));
        };
    useEffect(() => {
    const now = new Date();
    const month = now.getMonth() + 1;
    const fiscalQuarterMap = {
        9: 1, 10: 1, 11: 1,
        12: 2, 1: 2, 2: 2,
        3: 3, 4: 3, 5: 3,
        6: 4, 7: 4, 8: 4
    };
    const currentFiscalQuarter = fiscalQuarterMap[month];
    setQuarter(currentFiscalQuarter);
    }, []);
    useEffect(() => {
        if (!restrictedLoaded) {
            return;
        }
        setIsLoading(true);
        if (filter === "custom" && (!fromDate || !toDate)) {
            setIsLoading(false); 
            // Don't make the API call if dates are missing for the "custom" filter
            return;
        }
        let payload = {};
        if (filter === 'custom') {
            payload = {
                filter: filter, datefrom: format(new Date(fromDate), "yyyy-MM-dd"),
                dateto: format(new Date(toDate), "yyyy-MM-dd")
            }
            setShowDatePicker(false);
        }
        else if (["weekly", "monthly", "quarterly","FYdata"].includes(filter)) 
            {
                payload = {
                    filter: filter,
                    datefrom: "",
                    dateto: "",
                    period: period
                }; 
            }
        else {
            payload = {
                filter: parseInt(filter), datefrom: '',
                dateto: ''
            }
        }
        let URL2 = BaseUrl + "admin/loggedinnotordered";
        http.post(URL2, payload).then((response) => {
            setIsLoading(false);
            const actualMonth = parseInt(months);
            let filteredData = [];
            if (filter === 'monthly') {
                filteredData = response.data.data
                    .filter(item => item._id.month === actualMonth)
                    .flatMap(item => item.accounts)
                    .filter(account => !restrictedAccounts.includes(account.accountCode));
            } else if (filter === 'quarterly') {
                filteredData = response.data.data
                    .filter(item => item._id.quarter === quarter)
                    .flatMap(item => item.accounts)
                    .filter(account => !restrictedAccounts.includes(account.accountCode));
            }
            else if (filter === 'FYdata') {
                filteredData = response.data.data
                    .flatMap(item => item.accounts)
                    .filter(account => !restrictedAccounts.includes(account.accountCode));
            }
             else {
                // fallback for 'custom' or other filters where data is already flat
                filteredData = response.data.data.filter(
                    item => !restrictedAccounts.includes(item.accountCode)
                );
            }
            //const responseData = response.data.data.filter(item => !excludeTestids.includes(item.accountCode));
            //console.log(responseData,'responseData');
            setTopOrderedCustomers(filteredData);

        }).catch((err) => {
            setIsLoading(false);
            console.log(err);
        })

    }, [filter, fromDate, toDate, months, quarter, period,restrictedLoaded]);

    const changeFilterHandler = (e) => {

        setFilter(e.target.value);
        setFilterText(e.target.options[e.target.selectedIndex].text);
        if (e.target.value === 'custom') {
            setShowDatePicker(true);

        } else {
            setShowDatePicker(false);
            setFromDate(null);
            setToDate(null);
            setFilter(e.target.value);

        }
    };
    const changePeriodHandler = (e) => {
        const newPeriod = e.target.value;
        setPeriod(newPeriod); // update selected fiscal year in state
        //split fiscal year
        const [newStartYear, newEndYear] = newPeriod.split('-').map(Number);

        const fiscalStartMonthIndex = 8; // 0-based index for September

        const today = new Date();
        const currentFiscalYear = getCurrentFiscalYear();
        //compare sleted year with currentfiscalyear 
        const isCurrentFiscalYear = newPeriod === currentFiscalYear;

        // MONTHLY filter logic
        if (filter === 'monthly') {
            let visibleMonthNames = MonthNames;

            if (isCurrentFiscalYear) {
                // Calculate current fiscal month index 
                const currentMonthIndex = today.getMonth(); // 0-based
                const monthsPassedSinceFiscalStart =
                    (currentMonthIndex - fiscalStartMonthIndex + 12) % 12;
                const maxVisibleIndex = monthsPassedSinceFiscalStart;

                visibleMonthNames = MonthNames.slice(0, maxVisibleIndex + 1);
            }

            const selectedMonthIndex = MonthNames.indexOf(months);
            const isValidMonth =
                selectedMonthIndex >= 0 && selectedMonthIndex < visibleMonthNames.length;

            if (!isValidMonth) {
                const defaultMonthNumber = ((0 + fiscalStartMonthIndex) % 12) + 1;
                setMonths(String(defaultMonthNumber));
            }
        }

        // QUARTERLY filter logic
        if (filter === 'quarterly') {
            const currentQuarter = getCurrentFiscalQuarter();
            let maxQuarter = 4;

            if (isCurrentFiscalYear) {
                maxQuarter = currentQuarter;
            }

            if (parseInt(quarter) > maxQuarter) {
                setQuarter(maxQuarter > 0 ? String(maxQuarter) : "1");
            }

        }
    };
    const changeMonthHandler = (e) => {
        setMonths(e.target.value);
    };
    const formatDate = (dateString) => {
        const dateObject = new Date(dateString);
        const year = dateObject.getFullYear();
        const month = String(dateObject.getMonth() + 1).padStart(2, "0");
        const day = String(dateObject.getDate()).padStart(2, "0");
        return `${day}/${month}/${year}`;
    }

    const DateChange = (value, type) => {
        if (type === "from") {
            setFromDate(value);

            if (toDate && value && value > toDate) {
                setToDate(null);
            }
        } else if (type === "to") {
            if (!fromDate || value >= fromDate) {
                setToDate(value);
            } else {
                // Handle invalid date selection
                //alert("The 'To' date cannot be earlier than the 'From' date.");
                setToDate(null);
            }
        }
    };
      // Calculate dynamic pagination options
      const calculatePaginationOptions = (totalRecords, interval) => {
        const options = [];
        for (let i = interval; i <= totalRecords; i += interval) {
            options.push(i);
        }
        return options;
    };

    const filterLabelText =
    filter === 'weekly' ? `(Current Week | ${moment().startOf('isoWeek').format("DD/MM/YYYY")} - ${moment().endOf('isoWeek').format("DD/MM/YYYY")})`
        : filter === 'monthly' ? `(Monthly | ${MonthNames[(parseInt(months) + 12 - 9) % 12]} | ${period})`
        : filter === 'quarterly' ? `(Quarterly | ${quarterNames[quarter]} | ${period})`
        : filter === 'FYdata' ? `(FY Data | ${period})`
        : filter === 'custom' && fromDate && toDate
            ? `(${formatDate(fromDate)} - ${formatDate(toDate)})`
                : filtertext && filtertext !== "Custom Date"
                ? `(${filtertext})`
                : '(All)';

    // Open confirmation popup
    // Open confirmation popup only if there is data
    const handleConfirmExportToExcel = () => {
    if (!topOrderedCustomers || topOrderedCustomers.length === 0) {
        setShowNoDataAlert(true);
        return;
    }
    setShowExportAlert(true);
    };
    // Close popup without exporting
    const handleCloseExportAlert = () => {
        setShowExportAlert(false);
    };
    // Export filtered records
    const handleExportToExcel = () => {
        const records = topOrderedCustomers;
        if (!records || records.length === 0) return;
        const firstRowText = `Logged In - Not Ordered | Total Records: ${records.length} ${filterLabelText}`;
        const headers = ["Account Code", "Account Name", "Email Address", "Last Logged In"];
        const styledHeaders = headers.map(h => ({ v: h, s: { font: { bold: true }, alignment: { horizontal: "left" } } }));
        const rows = records.map(item => [
            item.accountCode,
            item.accountName,
            item.accountEmail,
            moment(item.lastLogin).format("DD/MM/YYYY HH:mm:ss")
        ]);
        // Worksheet with first row
        const worksheetData = [
            [{ v: firstRowText, s: { font: { bold: true }, alignment: { horizontal: "left" } } }],
            styledHeaders,
            ...rows
        ];
        const ws = XLSX.utils.aoa_to_sheet(worksheetData);
        // Merge first row across all columns
        ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } }];
        // Set column widths dynamically
        const columnWidths = headers.map((header, index) => {
            let maxLength = header.length;
            rows.forEach(row => {
                const val = row[index];
                maxLength = Math.max(maxLength, val ? val.toString().length : 0);
            });
            return { wch: maxLength + 5 }; // add extra space
        });
        ws["!cols"] = columnWidths;
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "LoggedInNotOrdered");
        const exportDateTime = moment().format("DD-MM-YYYY");
        const fileName = `Logged In - Not Ordered Report-${exportDateTime}.xlsx`;
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
        saveAs(blob, fileName);
        setShowExportAlert(false);
    };

    const totalRecords = topOrderedCustomers.length; // Get the total records count
    const options = [];

    for (let i = currentyear; i >= 2023; i--) {
        if (i === currentyear && currentMonth < 9) {
            continue;
          }
        const year = i;
        options.push(
            <option value={year + "-" + (year + 1)}>{year + "-" + (year + 1)}</option>
        );
    }

    const currentFiscalYear = getCurrentFiscalYear();
    let visibleMonthNames = MonthNames;
    if (period === currentFiscalYear) {
    // Limit to current fiscal month
    const fiscalIndex = (new Date().getMonth() - 8 + 12) % 12; // Sep=0, Oct=1, ... Aug=11
    visibleMonthNames = MonthNames.slice(0, fiscalIndex + 1);
    }
    let loadingbuffer = isLoading ? 'loading-buffer' : '';
    
    return (
        <div className={`chart-container chart-customers-loged ${loadingbuffer}`} style={{ verticalAlign: "top" }}>
            <div className="chart-Hdr">
                <div className="chart-Hdr-txt">
                    <h2>Customers Logged In - Not Ordered</h2>
                </div>
                <div className="chart-fltr">
                    {canAction('manage_dashboard', 'export') && (
                    <div className="prod-import-btn odr-expo-btn">
                        <a 
                            data-title="Export Filtered Records"
                            className="export-btn button title-tooltip title-left"
                            onClick={handleConfirmExportToExcel}
                        >
                            Export
                        </a>
                    </div>
                    )}

  <div className="chart-fltr" onMouseEnter={() => {
                    if (filter === "custom" && !showDatePicker) {
                        setShowDatePicker(true);
                    }
                }}
                    onMouseLeave={() => {
                        if (filter === "custom" && showDatePicker) {
                            setShowDatePicker(false);

                        }
                    }}>
                    {<select
                        value={filter}
                        onChange={(e) => changeFilterHandler(e)}
                    ><option value={0}>All</option>
                        <option value={"weekly"}>Current Week</option>
                        <option value={"monthly"}>Monthly</option>
                        <option value={"quarterly"}>Quarterly</option>
                        <option value={"FYdata"}>FY Data</option>
                        <option value={30}>Past 30 Days</option>
                        <option value={90}>Past 90 Days</option>
                        <option value={180}>Past 180 Days</option>
                        <option value={365}>Past 1 Year</option>
                        <option value={'custom'}>Custom Date</option>
                    </select>}

                    {showDatePicker && (
                        <div className="date-picker-container">
                            <label>From:</label>
                            <DatePicker
                                selected={fromDate}
                                onChange={(date) => DateChange(date, "from")}
                                showDisabledMonthNavigation
                                dateFormat="dd/MM/yyyy"
                                disablePast={true}
                                maxDate={new Date()}
                                placeholderText="Select Date"
                            />
                            <label>To:</label>
                            <DatePicker
                                selected={toDate}
                                showDisabledMonthNavigation
                                dateFormat="dd/MM/yyyy"
                                onChange={(date) => DateChange(date, "to")}
                                disablePast={true}
                                maxDate={new Date()}
                                placeholderText="Select Date"
                            />
                        </div>
                    )}
                    </div>
                    {filter === 'quarterly' && (
                            <select
                                style={{ width: "160px" }}
                                value={quarter}
                                onChange={(e) => setQuarter(Number(e.target.value))}
                            >
                                {/* {Object.entries(quarterNames).map(([q, label]) => (
                                <option key={q} value={q}>{label}</option>
                                ))} */}
                                 {getAvailableQuarters(period)}
                            </select>
                            )}
        
                            {filter === 'monthly' && <select style={{width:"50px"}} value={months} onChange={(e)=>changeMonthHandler(e)}>
                            {visibleMonthNames.map((monthName, index) => {
                                    const monthNumber = ((index + 8) % 12) + 1; // fiscal-to-calendar month number
                                    return (
                                        <option key={monthNumber} value={monthNumber}>
                                        {monthName}
                                        </option>
                                    );
                                    })}
                            </select>
        
                            }
                            {(filter === 'monthly' || filter === 'quarterly' || filter==='FYdata') &&<select
                                style={{ width: "170px" }}
                                value={period}
                                onChange={(e) => changePeriodHandler(e)}
                            >
                                {options}
                            </select>}
                </div>
                <div className="fltr-sub-val">
                    {topOrderedCustomers.length > 0 && (<span className='fltr-val'>Total Records: <strong>{topOrderedCustomers.length}</strong> {(["Current Week", "Monthly", "Quarterly",'FY Data'].includes(filtertext)) ? '' : filtertext != "" && filtertext != "Custom Date"
                                ? ' ('+ filtertext +')'
                                : filtertext === "Custom Date" && fromDate && toDate
                                    ? ' ('+formatDate(fromDate) + " - " + formatDate(toDate)+')'
                                    : ' ('+"All"+')'}</span>)}
                </div>
            </div>
            <DataTable
                columns={columns}
                data={topOrderedCustomers}
                customStyles={customStyles}
                noDataComponent={<div className='no-records-found'>Sorry, no data found for your filtered search.</div>}
                pagination
                paginationPerPage={10}
                //paginationRowsPerPageOptions={[20, 40, 60, 80, 100]}
                //paginationRowsPerPageOptions={paginationOptions}
                paginationComponentOptions={paginationComponentOptions}
                // paginationComponentOptions={{
                //     rowsPerPageText: '', // Hides "Rows per page"
                // }}

            />
            {showExportAlert && (
                <div className='custom-alert-pop paylater-popup'>
                    <div className='custom-alert-container'>
                    <div className='custom-alert-wrap'>
                        <div className='custom-alert-header'>
                        <h4>Alert</h4>
                        </div>
                        <div className='custom-alert-body'>
                        <p>Are you sure you want to export the data?</p>
                        <div className='alert-buttons'>
                            <a onClick={handleExportToExcel} className="popup-alert-btn button">OK</a>
                            <a onClick={handleCloseExportAlert} className="popup-alert-btn button">Cancel</a>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
            )}
            {showNoDataAlert && (
            <div className='custom-alert-pop paylater-popup'>
                <div className='custom-alert-container'>
                <div className='custom-alert-wrap'>
                    <div className='custom-alert-header'>
                    <h4>Notice</h4>
                    </div>
                    <div className='custom-alert-body'>
                    <p>There are no records are available for export.</p>
                    <div className='alert-buttons'>
                        <a onClick={() => setShowNoDataAlert(false)} className="popup-alert-btn button">OK</a>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            )}
        </div>
    );
};